import type OktaAuth from '@okta/okta-auth-js';

import { InterstateThemeProvider } from '@interstate/components/InterstateThemeProvider';
import { interstateThemeRegistry } from '@interstate/components/InterstateTheming/themes/interstateThemeRegistry';
import { MemoryRouter } from '@makemydeal/dr-react-18-wrappers';
import type { HostEnvironment } from '@makemydeal/dr-shared-ui-utils';
import { apiConfigHelper, OPEN_DEAL_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';
import { setOktaAuthForInterceptors, setupAuthNetworkInterceptsForModule } from '@makemydeal/dr-shared-network';

import { GlobalStyle } from '../globalStyle/GlobalStyle.style';
import { Bootstrapper } from '../shells/main/components/bootstrapper/Bootstrapper';
import { NewDealContextProvider } from '@makemydeal/dr-activities-open-deal';
import { NewDealForm } from './new-deal-form';
import { StoreProvider } from './components/StoreProvider';

export interface NewDealModuleProps {
    commonOrgId: string;
    oktaAuth: OktaAuth;
    environment: HostEnvironment;
    canDesk?: boolean;
    getAuthOverride?: () => Promise<string>;
    onCancel?: () => void;
    onCompleted?: () => void;
}

function initializeNetworkInterceptors(environment: HostEnvironment, oktaAuth: OktaAuth) {
    setupAuthNetworkInterceptsForModule(apiConfigHelper.apiUrlBuilderFromEnvironment(environment, OPEN_DEAL_APP_PREFIX));
    setOktaAuthForInterceptors(oktaAuth);
}

export function NewDealModule({
    oktaAuth,
    environment,
    canDesk,
    commonOrgId,
    getAuthOverride,
    onCancel,
    onCompleted
}: NewDealModuleProps) {
    initializeNetworkInterceptors(environment, oktaAuth);

    return (
        <>
            <GlobalStyle />
            <InterstateThemeProvider
                themeName="Interstate"
                applicationName="Open Deal"
                scopeName="Open Deal"
                themeRegistries={[interstateThemeRegistry]}
            >
                <StoreProvider environment={environment}>
                    <MemoryRouter>
                        <Bootstrapper environment={environment} coOrgId={commonOrgId}>
                            <NewDealContextProvider getAuthOverride={getAuthOverride} onCancel={onCancel} onCompleted={onCompleted}>
                                <NewDealForm canDesk={canDesk} environment={environment} />
                            </NewDealContextProvider>
                        </Bootstrapper>
                    </MemoryRouter>
                </StoreProvider>
            </InterstateThemeProvider>
        </>
    );
}

export default NewDealModule;
